export default __webpack_public_path__ + "static/media/tab-slider-5.2c75a4c8.png";